<template>
	<div v-if="user.warehouseCompany.zohoIntegration">
		<span v-if="user.zohoAuthenticated">Zoho Authenticated</span>
		<a
				v-else
				:href="user.zohoAuthUrl"
		>
			{{ $t('authenticateWithZoho') }}
		</a>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";

	export default {
		name: "ZohoAuthentication",
		computed: {
			...mapGetters(['user'])
		}
	}
</script>